export enum HipaaRequestEventType {
  Message = 'Message',
}
